function Notification({ message, type }) {
  return (
    <div className={`fixed top-4 right-4 p-4 rounded-md shadow-lg z-50 ${type === 'error' ? 'bg-red-600' : 'bg-green-600'} text-white text-sm`}>
      {message}
    </div>
  );
}

export default Notification;